<template lang="pug">
portal(v-if="dialogId" :to="`${dialogId}.content`" v-slot="{ close }")
  delete-account-cancel-request(
    v-slot="{ loading, init, deletedAt, deleteAt, daysToDelete }"
  )
    h2.mt-4.mb-5 Аккаунт был удалён {{ deletedAt }}
    p.ui-body-1.mb-1 У Вас есть #[strong {{ $tc(`${I18N_KEY.days}`, daysToDelete) }}], чтобы его восстановить
    p.ui-body-1 После #[strong {{ deletedAt }}] этого сделать не получится
    .d-flex.align-center.gap-12.mt-5
      dv-btn.flex-1(
        x-large
        outlined
        :loading="loading"
        @click="logout(); close();"
      ) Выйти
      dv-btn.flex-1(
        x-large
        :loading="loading"
        @click="init(); close();"
      ) Отменить удаление
</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';
import DeleteAccountCancelRequest from './DeleteAccountCancelRequest.vue';
import { I18N_KEY } from '@/constants/I18n.js';

export default {
  components: {
    DvBtn,
    DeleteAccountCancelRequest,
  },
  data() {
    return {
      I18N_KEY,
      dialogId: undefined,
    };
  },
  props: {},
  computed: {
    request() {
      return this.$user.deleteAccount.request;
    },
  },
  watch: {
    request: {
      handler(v) {
        if (v) {
          this.openDialog();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    openDialog() {
      this.dialogId = this.$dialogs.portal({
        attrs: {
          'max-width': 600,
          title: 'Аккаунт удалён',
          hideActions: true,
          hideHeader: true,
          persistent: true,
        },
        listeners: {
          'before:close': () => {
            this.dialogId = undefined;
          },
        },
      });
    },
    async logout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push({ name: 'main' });
    },
  },
};
</script>
